@import '../../../../../../constants/spacing.module.less';
@import (reference) 'ui-components/components/text/text.module.less';

.address-label-actions {
  padding-left: @space-8;

  display: inline-flex;
  align-items: center;
  gap: @space-4;
}

.lock-icon {
  width: 12px;

  svg {
    height: 12px;
    width: 12px;
    color: var(--default--icon--fill-color--11);
  }
}

.address {
  width: 100%;
  gap: @space-8;
}

.address-validation-status {
  .caption();
  display: flex;
  gap: @space-4;

  svg {
    width: 16px;
    height: 16px;
    transform: none;
  }
}

.validation-issue-message {
  white-space: normal;
  text-overflow: unset;
}

.read-only-address {
  .paragraph();
  color: var(--default--text-color--17);
}

.validate {
  margin-left: 4px;
  margin-top: 8px;
}

.icon {
  padding: 0;
  height: 16px;
  width: 16px;
  fill: var(--default--icon--fill-color--11);
  transform: none;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
